import HundredBricksAPI from '@lib/hundredBricksAPI/HundredBricksAPI';
import { APIError } from '@lib/api';
import InvestorProfile from '../InvestorProfile';
import INEFileExtensionIsInvalid from './INEFileExtensionIsInvalid';
import INEFileIsEmpty from './INEFileIsEmpty';
import INEFileSizeIsExceeded from './INEFileSizeIsExceeded';
import IdentificationError from './IdentificationError';
import IdentificationIsNotExpired from './IdentificationIsNotExpired';
import IdentificationNumberIsInvalid from './IdentificationNumberIsInvalid';
import InvalidInvestorId from './InvalidInvestorId';
import InvestorHasInvalidState from './InvestorHasInvalidState';
import InvestorNotFound from './InvestorNotFound';
import PassportFileExtensionIsInvalid from './PassportFileExtensionIsInvalid';
import PassportFileIsEmpty from './PassportFileIsEmpty';
import PassportFileSizeIsExceeded from './PassportFileSizeIsExceeded';
import IdentificationTypeIsUnsupported from './IdentificationTypeIsUnsupported';
class IdentificationAPI extends HundredBricksAPI {
    async updateExpiredIdentification(props) {
        const { type, number, frontFile, backFile, file } = props;
        const formData = new FormData();
        try {
            formData.append('identificationNumber', number);
            formData.append('type', type);
            if (type === 'ine' && frontFile && backFile) {
                formData.append('frontFile', frontFile);
                formData.append('backFile', backFile);
            }
            else if (type === 'passport' && file) {
                formData.append('file', file);
            }
            const { data } = await this.client.put('v2/profile/identification/expiration', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
            return new InvestorProfile(data);
        }
        catch (error) {
            if (error instanceof APIError) {
                switch (error.code) {
                    case 'INVALID_INVESTOR_ID':
                        throw new InvalidInvestorId({ cause: error });
                    case 'EMPTY_FILE':
                        throw new PassportFileIsEmpty({ cause: error });
                    case 'EMPTY_BACK_FILE':
                        throw new INEFileIsEmpty('back', { cause: error });
                    case 'EMPTY_FRONT_FILE':
                        throw new INEFileIsEmpty('front', { cause: error });
                    case 'MAXIMUM_FILE_SIZE_EXCEEDED':
                        throw new PassportFileSizeIsExceeded({ cause: error });
                    case 'MAXIMUM_BACK_FILE_SIZE_EXCEEDED':
                        throw new INEFileSizeIsExceeded('back', { cause: error });
                    case 'MAXIMUM_FRONT_FILE_SIZE_EXCEEDED':
                        throw new INEFileSizeIsExceeded('front', { cause: error });
                    case 'INCORRECT_FILE_EXTENSION':
                        throw new PassportFileExtensionIsInvalid({ cause: error });
                    case 'INCORRECT_BACK_FILE_EXTENSION':
                        throw new INEFileExtensionIsInvalid('back', { cause: error });
                    case 'INCORRECT_FRONT_FILE_EXTENSION':
                        throw new INEFileExtensionIsInvalid('front', { cause: error });
                    case 'INVALID_IDENTIFICATION_NUMBER':
                        throw new IdentificationNumberIsInvalid({ cause: error });
                    case 'UNSUPPORTED_IDENTIFICATION':
                        throw new IdentificationTypeIsUnsupported({ cause: error });
                    case 'INVESTOR_NOT_FOUND':
                        throw new InvestorNotFound({ cause: error });
                    case 'INVESTOR_INVALID_STATE':
                        throw new InvestorHasInvalidState({ cause: error });
                    case 'IDENTIFICATION_IS_NOT_EXPIRED':
                        throw new IdentificationIsNotExpired({ cause: error });
                    default:
                        throw new IdentificationError({ cause: error });
                }
            }
            else if (error instanceof Error) {
                throw new IdentificationError('Unexpected error while updating identification', { cause: error });
            }
            else {
                throw new IdentificationError(`Unexpected error while updating identification: '${error}'`);
            }
        }
    }
}
export default IdentificationAPI;
